<template lang="pug">
  div
    UserTile(v-if="selected" :user="selected" @click.native="popupOpened = true" :short="short" :size="size" :class="{ gray }")
    UserEmptyTile(v-else @select="popupOpened = true" :label="label" :editable="editable" :size="size")
    UserSelectPopup(v-if="popupOpened && editable" v-bind="$attrs" v-on="$listeners" :selected="selected" @close="popupOpened = false" :isClearable="isClearable")
</template>

<script>
import UserTile from '@/components/UserTile.vue';
import UserEmptyTile from '@/components/UserEmptyTile.vue';
import UserSelectPopup from '@/components/UserSelectPopup.vue';

export default {
  name: 'UserUniversalTile',
  components: { UserSelectPopup, UserEmptyTile, UserTile },
  model: { prop: 'selected', event: 'change' },
  props: {
    selected: Object,
    editable: Boolean,
    label: String,
    short: Boolean,
    size: Number,
    isClearable: {
      type: Boolean,
      default: true,
    },
    gray: Boolean,
  },
  data() {
    return {
      popupOpened: false,
    };
  },
};
</script>

<style scoped>
.gray {
  filter: grayscale(1);
}
</style>
